import { BlastEvent, SimulationConfig } from '@/types';
import { getRadiusAtAngle } from '@/logic/break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const AsteroidFieldAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  for (let i = 0; i < 18; i++) {
    const a = (i / 18) * Math.PI * 2 + progress;
    const dBase = e.maxRadius + progress * 700;
    const r = getRadiusAtAngle(a, e, dBase);
    ctx.save(); ctx.translate(e.pos.x + Math.cos(a) * r, e.pos.y + Math.sin(a) * r);
    ctx.rotate(progress * 15); ctx.beginPath();
    for (let j = 0; j < 5; j++) {
      const ja = (j / 5) * Math.PI * 2;
      const jr = 15 + Math.random() * 15;
      ctx.lineTo(Math.cos(ja) * jr, Math.sin(ja) * jr);
    }
    ctx.closePath(); ctx.fill(); ctx.restore();
  }
};

registerBlastAnimation('ASTEROID_FIELD', AsteroidFieldAnimation);
